export default __webpack_public_path__ + "static/so-b363aa905935658ea0d01c9edfb7e725.svg";